<template>
  <div>
    <!-- <div style="background: url(static/images/banner.png) no-repeat 100% 100%;background-color: #2F93b7"> -->
       <div class="banner">
      <el-header class="header">
        <div class="img1"><img src="static/images/logo.png">
          <div class="img2"><img src="static/images/m1.png"  ></div>
          <div class="img3"><img src="static/images/zz.png" style="width: 600px;"></div>
        </div>
      </el-header>
      <div style="background-color: rgba(37, 164, 180, 1);height: 60px;margin-bottom: 10px" >
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="rgba(37,164,180,0.5)"
          text-color="#fff"
          active-text-color="#ffd04b"
          style="margin: 10px auto;width: 1200px;"
          ref="elmenu"
        >
          <el-menu-item index="1"><router-link to="/" style="font-size: 14px;font-weight: bold;">首页</router-link></el-menu-item>
          <el-submenu index="2">
            <template slot="title">协会概况</template>
            <el-menu-item index="2-1"><router-link to="/Survey">协会简介</router-link></el-menu-item>
            <el-menu-item index="2-2"><router-link to="/Survey">服务范围</router-link></el-menu-item>
            <el-menu-item index="2-3"><router-link to="/Survey">主要业绩</router-link></el-menu-item>
            <el-menu-item index="2-4"><router-link to="/Survey">公示公告</router-link></el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">新闻动态</template>
            <el-menu-item index="3-1"><router-link to="/News">行业新闻</router-link></el-menu-item>
            <el-menu-item index="3-2"><router-link to="/News">实时动态</router-link></el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title">协会工作</template>
            <el-menu-item index="4-1"><router-link to="/Laws">法律法规</router-link></el-menu-item>
            <el-menu-item index="4-2"><router-link to="/Laws">协会通知</router-link></el-menu-item>
            <el-menu-item index="4-3"><router-link to="/Laws">党建工作</router-link></el-menu-item>
            <el-menu-item index="4-4"><router-link to="/Laws">安全生产标准化</router-link></el-menu-item>
            <el-menu-item index="4-5"><router-link to="/Laws">安全管家</router-link></el-menu-item>
            <el-menu-item index="4-6"><router-link to="/Laws">隐患排查治理</router-link></el-menu-item>
            <el-menu-item index="4-7"><router-link to="/Laws">化工园区安全提升服务</router-link></el-menu-item>
            <el-menu-item index="4-8"><router-link to="/Laws">安全仪表系统完整性评估</router-link></el-menu-item>
            <el-menu-item index="4-9"><router-link to="/Laws">安全培训</router-link></el-menu-item>
            <el-menu-item index="4-10"><router-link to="/Laws">标准宣贯</router-link></el-menu-item>
            <el-menu-item index="4-11"><router-link to="/Laws">团体标准制定</router-link></el-menu-item>
            <el-menu-item index="4-12"><router-link to="/Laws">往期回顾</router-link></el-menu-item>

          </el-submenu>
          <el-submenu index="5">
            <template slot="title">会员之家</template>
            <el-menu-item index="5-1"><router-link to="/Admissionnotice">入会须知</router-link></el-menu-item>
            <el-menu-item index="5-2"><router-link to="/Admissionnotice">会员单位</router-link></el-menu-item>
            <el-menu-item index="5-3"><router-link to="/Admissionnotice">下载专区</router-link></el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">教育培训</template>
            <el-menu-item index="6-1"><router-link to="/Publicityedu">宣传教育</router-link></el-menu-item>
            <el-menu-item index="6-2"><router-link to="/Publicityedu">培训平台</router-link></el-menu-item>
          </el-submenu>
<!--          <el-submenu index="7">
            <template slot="title">信息平台</template>-->
            <!--            <el-menu-item index="2-1">协会简介</el-menu-item>
                        <el-menu-item index="2-2">服务范围</el-menu-item>
                        <el-menu-item index="2-3">主要业绩</el-menu-item>
                        <el-menu-item index="2-4">信息公开</el-menu-item>-->
<!--          </el-submenu>-->
          <!--          <el-menu-item index="7">信息平台</el-menu-item>-->
          <el-submenu index="8">
            <template slot="title">专家服务</template>
            <el-menu-item index="8-1"><router-link to="/Technocracy">专家管理办法</router-link></el-menu-item>
            <el-menu-item index="8-2"><router-link to="/Technocracy">核心专家</router-link></el-menu-item>
            <el-menu-item index="8-3"><router-link to="/Technocracy">专家入库申请</router-link></el-menu-item>
            <el-menu-item index="8-4"><router-link to="/Technocracy">信息报备</router-link></el-menu-item>
            <el-menu-item index="8-5"><router-link to="/Technocracy">专家库</router-link></el-menu-item>
          </el-submenu>
          <el-submenu index="9">
            <template slot="title">联系我们</template>
            <el-menu-item index="9-1"><router-link to="/Contactus">联系我们</router-link></el-menu-item>
            <el-menu-item index="9-2"><router-link to="/Contactus">信息留言</router-link></el-menu-item>
          </el-submenu>
          <div v-if="username === ''" style="line-height: 60px;border-bottom-color: transparent;color: rgb(255, 255, 255);font-size: 19px;font-weight: bold;">
            <span :class="{'actcss':activeVar===10}"><router-link to="/Login" @click.native="login">登陆</router-link>&nbsp;</span>|<span :class="{'actcss':activeVar===11}">&nbsp;<router-link to="/Register" @click.native="register">注册</router-link></span>
          </div>
          <div v-else style="line-height: 60px;border-bottom-color: transparent;color: rgb(255, 255, 255);font-size: 19px;font-weight: bold">
            <span style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;float: left">{{username}}</span><span @click="exit">退出</span>
          </div>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from '../../assets/js/util.js';
export default {
  name: "Header",
  data(){
    return{
      activeVar:0,
      activeIndex: '1',
      activeIndex2: '1',
      username:'',
      token:'',
    }
  },
  mounted(){
    this.user()
    let name = sessionStorage.getItem('currentNav')
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if(name){
      this.activeIndex2 = name
    }
  },
  beforeRouteLeave(to, from, next){
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem('currentNav')
    next()
  },
  watch: {
    $route() {
      this.user()
      if(this.$route.path == '/'){
        this.activeIndex2 = '1'
        sessionStorage.setItem('currentNav', '1');
      } else if (this.$route.path == '/Survey') {
        this.activeIndex2 = '2-1'
        sessionStorage.setItem('currentNav', '2-1');
     }else if(this.$route.path == '/News'){
        this.activeIndex2 = '3-1'
        sessionStorage.setItem('currentNav', '3-1');
      }else if(this.$route.path == '/Laws'){
        this.activeIndex2 = '4-1'
        sessionStorage.setItem('currentNav', '4-1');
      }else if(this.$route.path == '/Admissionnotice'){
        this.activeIndex2 = '5-1'
        sessionStorage.setItem('currentNav', '5-1');
      }else if(this.$route.path == '/Publicityedu'){
        this.activeIndex2 = '6-1'
        sessionStorage.setItem('currentNav', '6-1');
      }else if(this.$route.path == '/Technocracy'){
        this.activeIndex2 = '8-1'
        sessionStorage.setItem('currentNav', '8-1');
      }else if(this.$route.path == '/Contactus'){
        this.activeIndex2 = '9-1'
        sessionStorage.setItem('currentNav', '9-1');
      }else if(this.$route.path == '/Login'){
        this.$refs.elmenu.activeIndex = null
        this.activeVar=10
      }else if(this.$route.path == '/Register'){
        this.$refs.elmenu.activeIndex = null
        this.activeVar=11
      }
    }
  },
  methods: {
    user(){
      let token = sessionStorage.getItem("token")
      let username = sessionStorage.getItem("username")
      if(token){
        this.username = username
        this.token = token
      }
    },
    login(){
      this.$refs.elmenu.activeIndex = null
      this.activeVar=10
    },
    register(){
      this.$refs.elmenu.activeIndex = null
      this.activeVar=11
    },
    exit(){
      sessionStorage.removeItem("token")
      sessionStorage.removeItem("username")
      this.$router.go(0)
    },
    handleSelect(key, keyPath) {
      Utils.$emit('demo',key);
      sessionStorage.setItem('currentNav', key);
      this.activeVar = 0
    }
  },
  /*created() {
    this.setCurrentRoute();
  }*/
}
</script>

<style  scoped>
  .banner{
    background: linear-gradient(to right,#fff,#2F93b7, #2F93b7,#1d8cb4,#8fbdce,#3c798f);
    /* width: 100%; */
    /* background: url(/static/images/banner.png) no-repeat 100% 100%,#2F93b7; */
    /* background-color: #2F93b7; */
  }
.router-link-active {
  text-decoration: none;
}
a{
  text-decoration: none;
  color: white;
}

.header {
  color: #333;
  text-align: center;
  line-height: 60px;
  height: 120px !important;
  padding-top: 10px;
  width: 96%;
  /* margin: 0px auto; */
}
.img1 img{
  float: left;
  padding:30px 0 0 20px;
}
.img2 img{
  width: 500px;
  padding-top: 38px;
  padding-left: 10px;
}
.img3 img{
  float: right;
  /* padding-right: 40px; */
  padding-top: 0px;
}
.el-menu-demo{
  width:70%;
   /*left: 15%;*/
}
.el-submenu{
  margin-left:1% !important;
  font-weight: bold !important;

}
div /deep/ .el-submenu__title{
  font-size: 14px !important;
  background-color: rgba(37, 164, 180, 0) !important;
}
div /deep/ .el-menu-item{

   background-color: rgba(37, 164, 180, 0) !important;
}
div /deep/ .el-submenu__title i{
    color: white !important;
  }
.actcss a{
  /*background: #ffD04b;*/
  border-bottom-color: rgb(255, 208, 75) ;
  color: rgb(255, 208, 75) ;
  background-color: rgba(37, 164, 180, 0.5) ;

}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue